import React from "react";
import { Canvas } from "@react-three/fiber";
import { RoomDemo } from "@/3d/components/demo/RoomDemo";
import { DemoLayout } from "@/dom/Demo/DemoLayout";
import { DemoRightColumn } from "@/dom/Demo/DemoRightColumn";
import { SETTINGS, SHADOW_SETTINGS } from "@/utils/settings";
import { Postprocessing } from "@/3d/components/Postprocessing";
import { Sky, Stats } from "@react-three/drei";
import { useDemoState } from "@/state/demoState";
import { APP_CANVAS_ID } from "@/utils/constants";

export const FurnitureDemo = () => {
    const view = useDemoState((state) => state.view);

    return (
        <DemoLayout
            canvas={
                <Canvas shadows={SHADOW_SETTINGS?.type ?? false} id={APP_CANVAS_ID}>
                    <RoomDemo />
                    <Postprocessing enabled={!!SETTINGS.postprocessing && view === "3d"} />
                    {view === "3d" && (
                        <Sky
                            distance={450000}
                            sunPosition={[1, 0.8, 0]}
                            rayleigh={0.5}
                            mieCoefficient={0.02}
                            mieDirectionalG={0.4}
                            turbidity={0.2}
                        />
                    )}
                    {SETTINGS.showStats && <Stats />}
                </Canvas>
            }
            right={<DemoRightColumn />}
        />
    );
};
